import {
    AccessSegment,
    ColumnMetadata,
    ColumnTypes,
} from "~/components/DataGrid";
import { AssetColumns } from "~/modules/assets/types";
import { AssetTableRowData } from "../types";
import { getMeasureValue } from "~/utils/getMeasureValue";
import { Emdash } from "~/components/Punctuation/Emdash";
import { CatalogMetricSlugs } from "~/modules/catalog/types";
import { DataGridDollarValue } from "~/components/DataGrid/DataGridDollarValue";

// // // //

export const NET_ASSET_VALUE_COLUMN: ColumnMetadata<
    AssetTableRowData,
    AssetColumns
> = {
    slug: AssetColumns.netAssetValueDollar,
    label: "NAV",
    tooltip: CatalogMetricSlugs.net_asset_value_dollar,
    type: ColumnTypes.dollar,
    sortsOn: AssetColumns.netAssetValueDollar,
    width: 110,
    access: {
        view: AccessSegment.Preview,
        sort: AccessSegment.Preview,
    },
    render: (item) => {
        const measure = getMeasureValue(item, "net_asset_value_dollar");
        return measure === null ? (
            <Emdash />
        ) : (
            <DataGridDollarValue value={measure.val} decimalPlaces={2} />
        );
    },
};
